import { Base } from './base.model';
import { Type } from "../decorators/type.decorator";
import { WelcomeDocument } from "./welcome-document.model";

export class Buyer extends Base {
  public name: string;
  public shortName: string;
  public gtagId: string;
  public referrerCode: number;
  public secondarySignerName: string;
  public secondarySignerEmail: string;
  public slogan: string;
  public stripeClientId: string;
  public url: string;
  public contactAddressLine1: string;
  public contactAddressLine2: string;
  public contactCity: string;
  public contactState: string;
  public contactZip: string;
  public secondarySignerTitle: string;
  public docusignIntegratorKey: string;
  public docusignUserId: string;
  public docusignPrivateKey: string;
  public buyerSignatureSettings: string;
  public landownerSignatureSettings: string;
  public landownerTitleSettings: string;
  public landownerEntitySettings: string;
  public stripeSecretKey: string;
  public stripePublicKey: string;
  @Type(WelcomeDocument) public welcomeDocuments: WelcomeDocument[];
}
